<template>
  <div class="page" v-if="init">
    <span style="text-decoration: underline;" class="headText">Расписание</span> <span class="headText"> / </span> <router-link :to="{name:'registry.queue'}" class="headText">Список записей</router-link>
    <GenerateSlots
      v-if="showModal"
      :doctor="doctor"
      @success="generate"
      @close="showModal = false"
    />
    <CreateSlot
      v-if="showCreateModal"
      :doctor="doctor"
      :date="createDate"
      @success="createSlot"
      @close="showCreateModal = false"
    />
    <UpdateSlotModal
      v-if="show"
      :patients="patients"
      :selectedSlot="selectedSlot"
      @remove="remove"
      @cancel="show = false"
      @success="updateSlot"
    />
    <RemoveSlots
      v-if="showRemoveModal"
      :doctor="doctor"
      @success="removeSlots"
      @close="showRemoveModal = false"
    />
    <Dialog v-model="is_exist">
      <div style="padding:1rem;">
        <h4>Внимание</h4>
        <p>
         Cледующие времена уже заняты в расписании другой специальностью:
        </p>
        <div style="max-height:40vh; overflow:auto">
          <p v-for="(slot, index) in exist_slots" :key="slot"><b>{{index+1}}.</b> {{slot | thetime}}</p>
        </div>
        <b-button variant="secondary" @click="is_exist = false; exist_slots = [];">OK</b-button>
      </div>
    </Dialog>
    <div class="vm-card vm-card-toolbar">
      <div class="schedule-tooltip">
        <div class="doctor-selector">
          <div class="headtitle">Выберите доктора...
          <!--searchInput v-model="searchDoctor" style="height:35px; width:auto" /-->
        </div>
        <!--transition name="fade">
          <ul class="specialities_list" style="max-height:40vh; overflow:auto">
            <li class="special_item" v-for="special in doctors"  v-bind:key="special.id">
              <div class="special" :class="{selected: special === doctor}" @click="doctor=special"><div>{{ special.name }} / {{ special.specialty }}</div> <div> {{ special.department }}</div></div>
            </li>
            <div v-if="!doctors.length > 0" class="empty-list">
            Нет врачей...
          </div>
          </ul>
        </transition-->
          <v-select
            placeholder="Выберите доктора..."
            v-model="doctor"
            :options="doctors"
            label="name"
          >
            <template #selected-option="{ name, department, specialty }">
              <span class="name">{{ name }}</span>
              <span class="more">({{ department }} / {{ specialty }})</span>
            </template>
            <template #option="{ name, department, specialty }">
              <div class="option-subtitle">
                {{ department }} / {{ specialty }}
              </div>
              <div class="option-title">{{ name }}</div>
            </template>
            <template v-slot:no-options="{ search, searching }">
                    <template v-if="searching">
                        Не найдено: <em>{{ search }}</em>.
                    </template>
                    <em style="opacity: 0.5;" v-else>Начните набирать...</em>
                </template>
          </v-select>
        </div>
        <!--div class="tooltip-buttons">
          <b-button
            type="button"
            size="sm"
            variant="primary"
            :disabled="doctor === null"
            @click="openCreateModal()"
            style="margin-right:5px"
          >
            Создать расписание
          </b-button>
          <b-button
            type="button"
            size="sm"
            variant="danger"
            :disabled="doctor === null"
            @click="showRemoveModal = true"
            style="margin-left:5px"
          >
            Очистить расписание
          </b-button>
        </div-->
      </div>
    </div>
    <div class="vm-card">
      <div style="display:flex" v-if="doctor !== null">
      <div style="margin-top:100px; margin-left:15px; margin-right:50px">
        <vue-slider v-model="minmax" :data="timing" :enable-cross="false" direction="ttb" 
        :marks="true"
        @change="changeTiming" :height="450" style="margin-right:10px"></vue-slider>
      </div>
      <FullCalendar id="box"
        v-if="doctor !== null"
        ref="fullCalendar"
        defaultView="timeGridWeek"
        @eventClick="eventClick"
        @dateClick="dateClick"
        @datesRender="datesRender"
        :scrollTime="scrollTime"
        :plugins="calendarPlugins"
        :locale="locale"
        :slotDuration="slotDuration"
        :minTime="minTime"
        :maxTime="maxTime" :height="700"
        :slotLabelFormat="slotLabelFormat"
        :slotLabelInterval="slotDuration"
        :allDaySlot="false"
        :editable="false"
        :events="events" :custom-buttons="customButtons"
        :header="{left: 'title', center: 'createSlot,clearSlot', right:'min15,min30,min60  today prev,next'}"
      />
      </div>
      <b-button v-if="visibleTop" variant="info" class="upButton" @click="scrollToTop">
        <span class="material-icons" style="margin-top:5px">expand_less</span>
      </b-button>
    </div>
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import bootstrapPlugin from '@fullcalendar/bootstrap';
import ruLocale from '@fullcalendar/core/locales/ru';
import GenerateSlots from './Modals/GenerateSlots';
import UpdateSlotModal from './Modals/UpdateSlot';
import RemoveSlots from './Modals/RemoveSlots';
import CreateSlot from './Modals/CreateSlot';
import Dialog from '@app/components/uikit/Dialog';
import {
  doctorApi,
  timetableApi,
  patientApi,
  scheduleApi
} from '../../services';
import moment from 'moment';
import toastr from 'toastr';
import searchInput from '@app/components/uikit/searchInput';
import { debounce } from 'lodash';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';

export default {
  components: {
    CreateSlot,
    RemoveSlots,
    UpdateSlotModal,
    GenerateSlots,
    FullCalendar,
    //searchInput,
    VueSlider,
    Dialog
  },
  data() {
    return {
      init: false,
      initCalendar: false,
      show: false,
      showModal: false,
      showCreateModal: false,
      showRemoveModal: false,
      patients: [],
      createDate: null,
      selectedSlot: {
        uuid: null,
        start: null,
        end: null,
        patient: null,
        reserve: null
      },
      doctorName: null,
      doctor: null,
      doctors: [],
      locale: ruLocale,
      calendarPlugins: [
        bootstrapPlugin,
        interactionPlugin,
        dayGridPlugin,
        timeGridPlugin
      ],
      slotDuration: '00:15:00',
      scrollTime: '12:00:00',
      minTime: '07:00:00',
      maxTime: '20:00:00',
      slotLabelFormat: {
        hour: '2-digit',
        minute: '2-digit',
        omitZeroMinute: false,
        meridiem: 'short'
      },
      events: [],
      start: null,
      end: null,
      date: null,
      activeStart: null,
      activeEnd: null,
      searchDoctor: '',
      customButtons: {
        createSlot: {
          text: 'Составить расписание',
          click: () => { this.openCreateModal(); }
        },
        clearSlot: {
          text: 'Очистить расписание',
          click: () => { this.showRemoveModal = true; }
        },
        min15: {
          text: '15мин',
          click: () => { this.slotDuration = '00:15:00'; }
        },
        min30: {
          text: '30мин',
          click: () => { this.slotDuration = '00:30:00'; }
        },
        min60: {
          text: '1час',
          click: () => { this.slotDuration = '01:00:00'; }
        }
      },
      visibleTop: false,
      timing: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00','06:00','07:00','08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00'
      ],
      minmax: ['00:00', '23:00'],
      exist_slots: [],
      is_exist: false
    };
  },
  filters: {
    thetime: function(value) {
      const format = 'DD.MM.YYYY в HH:mm';
      return moment(value).format(format);
    }
  },
  watch: {
    doctor: async function(newDoctor, oldDoctor) {
      // Инициализацию должен отрендерить methods.datesRender
      if (newDoctor && oldDoctor !== null) {
        await this.load(newDoctor.id);
      }
      setTimeout(() => {
          this.$refs.fullCalendar.$el.addEventListener('resize', this.heightCalendar);
          const elm = this.$refs.fullCalendar.$el;
          elm.scrollIntoView({behavior: 'smooth', block: 'end', inline: 'start'});
        },500);
    },
    searchDoctor: debounce(async function(str) {
                        const loading = this.$loading.show();
                        try {  console.log(str);
                          const { items } = await doctorApi.getAll(undefined, undefined, str);
                          if (items) { console.log(items);
                            this.doctors = items.map(item => ({
                              id: item.id,
                              name: `${item.employee.lastName} ${item.employee.firstName} ${item.employee.middleName}`,
                              department: item.department.title,
                              specialty: item.specialty.title
                            }));
                          } else {
                            this.doctors = [];
                          }
                        } catch (e) {
                          console.error(e);
                        }
                        this.init = true;
                        loading.hide();
    }, 500)
  },
  async created() {
    const loading = this.$loading.show();
    try {
      const { items } = await doctorApi.getAll();
      this.doctors = items.map(item => ({
        id: item.id,
        name: `${item.employee.lastName} ${item.employee.firstName} ${item.employee.middleName}`,
        department: item.department.title,
        specialty: item.specialty.title
      }));
      if (this.$route.params.doctor) {
        this.doctor = this.doctors.find(slot => slot.id === this.$route.params.doctor);
      }
    } catch (e) {
      console.error(e);
    }
    this.init = true;
    loading.hide();
  },
  methods: {
    heightCalendar() {
      console.log(this.$refs.fullCalendar.$el);
    },
    changeTiming(evt) {
      this.minTime = evt[0] + ':00';
      this.maxTime = evt[1] + ':00';
    },
    datesRender({ view }) {
      const { activeStart, activeEnd } = view;
      const format = 'YYYY-MM-DD';
      this.activeStart = moment(activeStart).format(format);
      this.activeEnd = moment(activeEnd).format(format);
      this.load(this.doctor.id);
    },
    dateClick({ date }) {
      this.showCreateModal = true;
      this.createDate = date;
    },
    openCreateModal() {
      this.showModal = true;
    },
    async remove(uuid) {
      this.show = false;
      await timetableApi.remove(uuid).then(res => {

      }).catch(error => {
        this.$bvToast.toast(error, {
          title: 'Ошибка',
          autoHideDelay: 10000,
          variant: 'danger'
        });
      });
      await this.reload();
    },
    async createSlot(payload) {
      this.showCreateModal = false;
      const loading = this.$loading.show();
      try {
        await timetableApi.create(payload);
      } catch (errors) {
        const content = errors.join('\n');
        this.$bvToast.toast(content, {
          title: 'Ошибка',
          autoHideDelay: 10000,
          variant: 'danger'
        });
      }
      await this.loadDate(payload.doctor);
      loading.hide();
    },
    async removeSlots(payload) {
      try {
        await scheduleApi.clear(payload);
        this.showRemoveModal = false;
      } catch (errors) {
        const content = Array.isArray(errors)
          ? errors.join('\n')
          : errors.message;
        this.$bvToast.toast(content, {
          title: 'Ошибка',
          autoHideDelay: 10000,
          variant: 'danger'
        });
      }
      await this.load(payload.doctor);
    },
    async generate(payload) {
      try {
        const data = await scheduleApi.generate(payload);
        this.showModal = false;
        if (data.data.exists_slot.length > 0) {
          this.is_exist = true;
          this.exist_slots = data.data.exists_slot;
        }
      } catch (errors) {
        const content = Array.isArray(errors)
          ? errors.join('\n')
          : errors.message;
        this.$bvToast.toast(content, {
          title: 'Ошибка',
          autoHideDelay: 10000,
          variant: 'danger'
        });
      }
      await this.load(payload.doctor);
    },
    async reload() {
      this.showModal = false;
      await this.load(this.doctor.id);
    },
    async load(uuid) {
      const loading = this.$loading.show();
      await this.loadDate(uuid);
      loading.hide();
    },
    formatTime(time) {
      return time > 9 ? '' + time : '0' + time;
    },
    delay(ms) {
      return new Promise(res => setTimeout(res, ms));
    },
    async loadDate(uuid) {
      const slots = await timetableApi.getAllByDoctor(
        uuid,
        this.activeStart,
        this.activeEnd
      );
      let time = null;
      let laterDate = null;
      this.events = slots.map(slot => {
        const start = moment(slot.start_time);
        const hour = start.hour();
        const minute = start.minute();
        const second = start.second();
        const sum = hour * 60 * 60 + minute * 60 + second;
        if (laterDate) {
          if (!(laterDate < sum)) {
            laterDate = sum;
            time = { hour, minute, second };
          }
        } else {
          laterDate = sum;
          time = { hour, minute, second };
        }
        return {
          id: slot.id,
          end: new Date(slot.end_time),
          start: new Date(slot.start_time),
          className: 
            new Date(slot.end_time) < new Date() ? ['prevRecord'] :
            new Date(slot.start_time) < new Date() && new Date() < new Date(slot.end_time) ? ['currentRecord'] :
            slot.is_reserve
            ? ['reserve'] // '#bdbdbd'
            : !slot.patient && slot.record_mode === 1
            ? ['phoneRecord'] //'#5599ff'
            : !slot.patient && slot.record_mode === 0
            ? ['anyRecord'] //'#7cb342'
            : slot.patient && slot.patient.good
            ? ['goodPatient'] //'#e535b9'
            : slot.patient && !slot.patient.good
            ? ['notgoodPatient'] //'#e53935'
            : ['freeSlot'], //'#7cb342',
          extendedProps: {
            isReserve: slot.is_reserve,
            patient: slot.patient
          },
          title: slot.patient ? slot.patient.lastName + ' ' + slot.patient.firstName : '',
          expandRows: true
        };
      });
      const scrollTime = time
        ? `${this.formatTime(time.hour)}:${this.formatTime(
            time.minute
          )}:${this.formatTime(time.second)}`
        : '06:00:00';
      const calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.scrollToTime(scrollTime);
    },
    resetSlotForm() {
      this.selectedSlot = {
        uuid: null,
        start: null,
        end: null,
        patient: null,
        reserve: null
      };
    },
    async updateSlot(payload) {
      this.show = false;
      const slot = {
        patient: payload.patient,
        is_reserve: payload.reserve
      };
      await timetableApi.update(payload.id, slot).then(res => {
      }).catch(error => {
        this.$bvToast.toast(error, {
          title: 'Ошибка',
          autoHideDelay: 10000,
          variant: 'danger'
        });
      });
      await this.load(this.doctor.id);
    },
    async eventClick({ event }) {
      moment.locale('ru');
      const { id, start, end, extendedProps } = event;
      const { items } = await patientApi.getAll();
      this.patients = items.map(item => this.formattedPatient(item));
      const patient = extendedProps.patient
        ? this.formattedPatient(extendedProps.patient)
        : null;
      this.selectedSlot = {
        id: id,
        start: moment(start).format('HH:mm'),
        end: moment(end).format('HH:mm'),
        day: moment(start).format('DD MMMM'),
        patient,
        reserve: extendedProps.isReserve
      };
      this.show = true;
    },
    formattedPatient(patient) {
      return {
        id: patient.id,
        phone: patient.phone,
        name: `${patient.lastName} ${patient.firstName} ${patient.middleName}`
      };
    },
    initTopButton() {
      if (window.scrollY > 250) {
        this.visibleTop = true;
      } else {
        this.visibleTop = false;
      }
    },
    scrollToTop() {
      window.scrollTo({top: 0, behavior: 'smooth'});
    }
  },
  mounted() {
    this.minmax = [this.minTime.split(':')[0] +':' + this.minTime.split(':')[1], this.maxTime.split(':')[0] +':' + this.maxTime.split(':')[1]];
    window.addEventListener('scroll', this.initTopButton); console.log(this.minmax);

  }
};
</script>

<style lang="scss" scoped>
@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';
@import '~@fullcalendar/timegrid/main.css';
@import '~vue-select/dist/vue-select.css';

h2 {
  color: #737373; 
  font-size: 1.5rem;
  margin-bottom: 2rem;
}
.headText {
  color: #737373; 
  font-size: 1.5rem;
  margin-bottom: 2rem;
  font-weight: 500;
  line-height: 1.2;
  cursor: pointer;
}
.headText:hover {
  color: black;
}
.schedule-tooltip {
  display: flex;
  flex-direction: column;
}
.style-chooser .vs__search::placeholder {
  color: #616161;
}
.selected-title {
  font-size: 0.9rem;
}
.tooltip-buttons {
  margin-left: auto;
  margin-bottom: 24px;
}
.selected-subtitle {
  font-size: 0.7rem;
}
.option-title {
  font-size: 1rem;
}
.option-subtitle {
  font-size: 0.8rem;
  font-weight: 300;
  color: #616161;
}
.v-select {
  width: 100%;
}
.v-select .vs__selected .more {
  font-size: 0.8rem;
  margin-left: 6px;
  color: #616161;
  font-weight: 300;
}
.v-select .vs__dropdown-option--highlight .option-subtitle,
.v-select .vs__dropdown-option:hover .option-subtitle {
  color: #fff;
}
.fc-time-grid .fc-event {
  padding: 0;
  cursor: pointer;
}
::v-deep .fc-toolbar.fc-header-toolbar {
  margin: 0;
  padding: 1rem;
}
::v-deep .fc-event {
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .fc-body > tr > .fc-widget-content {
  border: 0;
  border-top: 1px solid #ddd;
}
.vm-card-calendar {
  overflow: hidden;
}
.vm-card-toolbar {
  padding: 1rem;
  margin-bottom: 1rem;
}
.vm-card-toolbar .v-select {
  margin-bottom: 1rem;
}

::v-deep .fc table {
  border-spacing: 0 !important;
  border-collapse: collapse;
}
::v-deep .form .fc-widget-header {
  border: 1px solid !important;
}
::v-deep .fc td {
  border-style: solid;
}

::v-deep .fc-createSlot-button {
  background: linear-gradient(to top, lightcyan, transparent);
}
::v-deep .fc-clearSlot-button {
  background: linear-gradient(to top, rgb(255, 205, 205), transparent);
}
::v-deep .fc-createSlot-button:hover {
  background: rgb(93, 184, 184);
  color: white;
}
::v-deep .fc-clearSlot-button:hover {
  background: rgb(211, 145, 145);
  color: white;
}
::v-deep .searhIcon {
  color: #616161;
}
::v-deep .backInp {
  align-self: center;
  height: 35px;
}
::v-deep .searching {
  height: 25px;
}
.upButton {
  position: fixed;
  bottom: 2rem;
  right: 13rem;
  z-index: 10;
  opacity: 0.5;
  border-radius: 25px;
  width: 50px;
  height: 50px;
}
.upButton:hover {
  opacity: 1;
}

::v-deep .fc-min15-button:hover {
  color: #616161;
}
::v-deep .fc-min30-button:hover {
  color: #616161;
}
::v-deep .fc-min60-button:hover {
  color: #616161;
}



::v-deep .reserve {
  background: linear-gradient(to top, #bdbdbd, #cfcfcf);
  cursor: pointer;
}
::v-deep .phoneRecord {
  background: linear-gradient(to top, #5599ff, #8ab7fa);
  cursor: pointer;
}
::v-deep .prevRecord {
  background: linear-gradient(to top, #627085, #8f9aaa);
  cursor: pointer;
}
::v-deep .currentRecord {
  background: linear-gradient(to top, #9b9da0, #cecfd1);
  cursor: pointer;
}
::v-deep .anyRecord {
  background: linear-gradient(to top, #7cb342, #99d855);
  cursor: pointer;
}
::v-deep .goodPatient {
  background: linear-gradient(to top, #e535b9, #ff66d9);
  cursor: pointer;
}
::v-deep .notgoodPatient {
  background: linear-gradient(to top, #e53935, #ff6966);
  cursor: pointer;
}
::v-deep .freeSlot {
  background: linear-gradient(to top, #7cb342, #99d855);
  cursor: pointer;
}


::v-deep .reserve:hover {
  background: linear-gradient(to bottom, #bdbdbd, #cfcfcf);
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
}
::v-deep .phoneRecord:hover {
  background: linear-gradient(to bottom, #5599ff, #8ab7fa);
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
}
::v-deep .prevRecord:hover {
  background: linear-gradient(to bottom, #627085, #8f9aaa);
  font-size: 16px;
  font-weight: 500;
}
::v-deep .currentRecord:hover {
  background: linear-gradient(to bottom, #9b9da0, #cecfd1);
  font-size: 16px;
  font-weight: 500;
}
::v-deep .anyRecord:hover {
  background: linear-gradient(to bottom, #7cb342, #99d855);
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
}
::v-deep .goodPatient:hover {
  background: linear-gradient(to bottom, #e535b9, #ff66d9);
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
}
::v-deep .notgoodPatient:hover {
  background: linear-gradient(to bottom, #e53935, #ff6966);
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
}
::v-deep .freeSlot:hover {
  background: linear-gradient(to bottom, #7cb342, #99d855);
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
}


::v-deep .reserve:active {
  background: linear-gradient(to bottom, #bdbdbd91, #cfcfcfcc);
}
::v-deep .phoneRecord:active {
  background: linear-gradient(to bottom, #5599ff91, #8ab7facc);
}
::v-deep .anyRecord:active {
  background: linear-gradient(to bottom, #7cb34291, #99d855cc);
}
::v-deep .goodPatient:active {
  background: linear-gradient(to bottom, #e535b991, #ff66d9cc);
}
::v-deep .notgoodPatient:active {
  background: linear-gradient(to bottom, #e5393591, #ff6966cc);
}
::v-deep .freeSlot:active {
  background: linear-gradient(to bottom, #7cb34291, #99d855cc);
}
</style>
